import { render, staticRenderFns } from "./CatalogFilters.vue?vue&type=template&id=e8018650&"
import script from "./CatalogFilters.vue?vue&type=script&lang=js&"
export * from "./CatalogFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports